import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { AuditStatus } from '@/utils/AuditTrail/types';
import { STATUS_CONFIG } from '@/utils/AuditTrail/constants';

export const StatusBadge: React.FC<{ status: AuditStatus }> = ({ status }) => {
  const cfg = STATUS_CONFIG[status];
  const Icon = cfg.icon;
  return (
    <Badge className={cn('gap-1', cfg.className)}>
      <Icon className="h-3 w-3" />
      {cfg.label}
    </Badge>
  );
};
